import { toastr } from "react-redux-toastr";
import { client_v2, getApiErrorMessage } from "utils/api";

export const getPackerDashboard =
  ({ date, user_id }) =>
  async (dispatch, useState) => {
    try {
      const {
        current_user: { role },
      } = useState();
      if (!user_id || !date) {
        if (role === "admin") {
          const { data } = await client_v2.get(
            `/stats/packer_dashboard_histogram?date=${date}`
          );
          dispatch({
            type: "PACKER_DASHBOARD_SUCCESS",
            data,
          });
          return;
        }
        dispatch({
          type: "PACKER_DASHBOARD_EMPTY",
        });
        return;
      }
      dispatch({
        type: "PACKER_DASHBOARD_LOADING",
      });

      const { data, packer } = await client_v2.get(
        `/stats/packer_dashboard?date=${date}&user_id=${user_id}`
      );
      dispatch({
        type: "PACKER_DASHBOARD_SUCCESS",
        data,
        packer,
      });
    } catch (error) {
      dispatch({ type: "PACKER_DASHBOARD_FAILURE" });
      toastr.error("Błąd", "Wystąpił błąd podczas pobierania danych");
    }
  };

export const createUserAdjustment = async ({
  amount,
  description,
  user_id,
  date,
}) => {
  try {
    await client_v2.post("/user_adjustments", {
      amount,
      description,
      user_id,
      date,
    });

    toastr.success("Sukces", "Uwaga została utworzona");
  } catch (error) {
    toastr.error("Błąd", getApiErrorMessage(error));
    throw error;
  }
};
